<mat-expansion-panel class="edit-filter-expansion-panel" [expanded]="expanded()">
  <mat-expansion-panel-header i18n="@@core.filter.edit-filters">Edit filters</mat-expansion-panel-header>
  @for (filter of editableFilters(); track filter.id) {
    <div class="edit-attribute-filters">
      @if (isSliderFilter(filter)) {
        <div class="edit-filter-wrapper">
          <div class="editable-slider-filter-title" [class.disabled]="isSliderFilterDisabled(filter)">
            {{ getSliderFilterLabel(filter) }}
          </div>
          <div class="editable-slider-filter-content">
            <tm-slider-filter
              [sliderFilter]="filter"
              (valueChange)="updateSliderFilterValue($event, filter)"
              (betweenValuesChange)="updateBetweenSliderFilterValues($event, filter)"></tm-slider-filter>
          </div>
        </div>
      }
      @else if (isCheckboxFilter(filter)) {
        <div class="edit-filter-wrapper">
          <div class="editable-checkbox-filter">
            <tm-checkbox-filter
              [checkboxFilter]="{filter, substringFilters: getSubstringFilters(filter)}"
              (valueChecked)="updateCheckboxFilterValue($event.value, $event.checked, $event.substringFilter, filter)"
              (allValuesChecked)="updateAllCheckboxFilterValues($event.checked, $event.regularValues, $event.substringValues, filter)"></tm-checkbox-filter>
          </div>
        </div>
      }
      @else if (isSwitchFilter(filter)) {
        <div class="edit-filter-wrapper">
          <div class="editable-switch-filter-title">
            {{ filter.attributeAlias ?? filter.attribute }}
          </div>
          <div class="editable-switch-filter-content">
            <tm-switch-filter
              [switchFilter]="filter"
              (valueChange)="updateSwitchFilterValue($event, filter)"></tm-switch-filter>
          </div>
        </div>
      }
      @else if (isDatePickerFilter(filter)) {
        <div class="edit-filter-wrapper">
          <div class="editable-date-picker-filter-title">
            {{ (filter.attributeAlias ?? filter.attribute) + ' ' + getConditionLabel(filter.condition) }}
          </div>
          <div class="editable-date-picker-filter-content">
            <tm-date-picker-filter
              [datePickerFilter]="filter"
              (dateChange)="updateDateFilterValue($event, filter)"
              (betweenDatesChange)="updateBetweenDateFilterValues($event, filter)"></tm-date-picker-filter>
          </div>
        </div>
      }
      @else if (isDropdownListFilter(filter)) {
        <div class="edit-filter-wrapper">
          <div class="editable-dropdown-list-filter-title">
            {{ filter.attributeAlias ?? filter.attribute }}
          </div>
          <div class="editable-dropdown-list-filter-content">
            <tm-dropdown-list-filter
              [dropdownListFilter]="filter"
              [uniqueValues]="getUniqueValues$(filter.attribute) | async"
              (valueSelected)="updateCheckboxFilterValue($event.value, $event.selected, false, filter)"></tm-dropdown-list-filter>
          </div>
        </div>
      }
      @else if (isTextFilter(filter)) {
        <div class="edit-filter-wrapper">
          <div class="editable-text-filter-title">
            {{ (filter.attributeAlias ?? filter.attribute) + ' ' + getConditionLabel(filter.condition) }}
          </div>
          <div class="editable-text-filter-content">
            <tm-text-filter
              [textFilter]="filter"
              (valueChange)="updateTextFilterValue($event, filter)"></tm-text-filter>
          </div>
        </div>
      }
    </div>
  }
</mat-expansion-panel>
